export default __webpack_public_path__ + "static/media/5.80833a3f.jpg";